var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("link", {
        attrs: {
          rel: "stylesheet",
          href:
            "https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@40,400,0,0"
        }
      }),
      _vm._v(" "),
      _c(
        "v-tooltip",
        { attrs: { bottom: "" } },
        [
          _c(
            "v-btn",
            {
              attrs: { slot: "activator", color: "#007681", dark: "" },
              nativeOn: {
                click: function($event) {
                  return function() {
                    _vm.dialog = _vm.dialog ? false : true
                  }.apply(null, arguments)
                }
              },
              slot: "activator"
            },
            [
              _c("span", { staticClass: "material-symbols-outlined" }, [
                _vm._v(" calendar_month ")
              ]),
              _vm._v("CALENDARIO\n    ")
            ]
          ),
          _vm._v(" "),
          _c("span", [_vm._v("Calendario de vacaciones")])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", width: "1000" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { color: "#007681", dark: "" } },
                [
                  _c("span", { staticClass: "material-symbols-outlined" }, [
                    _vm._v(" calendar_month")
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-toolbar-title",
                    {
                      staticStyle: {
                        "font-family":
                          "Century Gothic, CenturyGothic, AppleGothic, sans-serif"
                      }
                    },
                    [_vm._v("Calendario de vacaciones")]
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c(
                        "Transition",
                        { attrs: { name: "slide-fade" } },
                        [
                          _c(
                            "v-div",
                            { staticClass: "div-color" },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "letra",
                                  staticStyle: {
                                    "background-color": "#9FAEE5"
                                  },
                                  attrs: { block: "" }
                                },
                                [
                                  _vm._v(
                                    "\n                  Pendiente aprob. uso\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "letra",
                                  staticStyle: {
                                    "background-color": "#C5E86C"
                                  },
                                  attrs: { block: "" }
                                },
                                [
                                  _vm._v(
                                    "\n                  Aprobado uso vacación\n                "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "", "justify-center": "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c(
                                "v-sheet",
                                { attrs: { height: "700" } },
                                [
                                  _c("v-calendar", {
                                    ref: "calendar",
                                    attrs: {
                                      type: "month",
                                      end: _vm.end,
                                      value: _vm.today,
                                      color: "primary",
                                      locale: "es"
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "day",
                                        fn: function(ref) {
                                          var date = ref.date
                                          return _vm._l(
                                            _vm.eventsMap[date],
                                            function(event) {
                                              return _c(
                                                "v-card",
                                                { key: event.id },
                                                [
                                                  _c(
                                                    "v-menu",
                                                    {
                                                      attrs: {
                                                        "full-width": "",
                                                        "offset-x": ""
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function(ref) {
                                                              var on = ref.on
                                                              return [
                                                                !event.time
                                                                  ? _c(
                                                                      "div",
                                                                      _vm._g(
                                                                        {
                                                                          class:
                                                                            event.estado ==
                                                                            7
                                                                              ? "permiso-aprobado"
                                                                              : "permiso-rechazado",
                                                                          style:
                                                                            "background-color: " +
                                                                            event.color +
                                                                            ";",
                                                                          domProps: {
                                                                            innerHTML: _vm._s(
                                                                              event.title
                                                                            )
                                                                          }
                                                                        },
                                                                        on
                                                                      )
                                                                    )
                                                                  : _vm._e()
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                      model: {
                                                        value: event.open,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            event,
                                                            "open",
                                                            $$v
                                                          )
                                                        },
                                                        expression: "event.open"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-card",
                                                        {
                                                          attrs: {
                                                            color:
                                                              "grey lighten-4",
                                                            "min-width":
                                                              "350px",
                                                            flat: ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-toolbar",
                                                            {
                                                              attrs: {
                                                                color:
                                                                  "primary",
                                                                dark: ""
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "v-btn",
                                                                {
                                                                  attrs: {
                                                                    icon: ""
                                                                  }
                                                                },
                                                                [
                                                                  _c("v-icon", [
                                                                    _vm._v(
                                                                      "edit"
                                                                    )
                                                                  ])
                                                                ],
                                                                1
                                                              ),
                                                              _vm._v(
                                                                "\n                            " +
                                                                  _vm._s(
                                                                    event.title
                                                                  ) +
                                                                  "\n\n                            "
                                                              ),
                                                              _c("v-spacer")
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-card-title",
                                                            {
                                                              attrs: {
                                                                "primary-title":
                                                                  ""
                                                              }
                                                            },
                                                            [
                                                              _c("span", {
                                                                domProps: {
                                                                  innerHTML: _vm._s(
                                                                    event.details
                                                                  )
                                                                }
                                                              })
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-card-actions",
                                                            [
                                                              _c(
                                                                "v-btn",
                                                                {
                                                                  attrs: {
                                                                    flat: "",
                                                                    color:
                                                                      "blue"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " Cerrar "
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            }
                                          )
                                        }
                                      }
                                    ]),
                                    model: {
                                      value: _vm.start,
                                      callback: function($$v) {
                                        _vm.start = $$v
                                      },
                                      expression: "start"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { shrink: "" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.$refs.calendar.prev()
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { dark: "", left: "" } },
                                    [_vm._v(" keyboard_arrow_left ")]
                                  ),
                                  _vm._v(
                                    "\n                Anterior\n              "
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.$refs.calendar.next()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                Siguiente\n                "
                                  ),
                                  _c(
                                    "v-icon",
                                    { attrs: { right: "", dark: "" } },
                                    [_vm._v(" keyboard_arrow_right ")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      nativeOn: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("cancel")]),
                      _vm._v(" CERRAR\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3998c14c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3998c14c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/vacacion_uso/components/CalendarioVacaciones.vue
// module id = null
// module chunks = 